// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__3ML99","slider__img":"Slider_slider__img__b051R","btns":"Slider_btns__3CXLW","btns__icon_right":"Slider_btns__icon_right__Y9Svv"};